export const apiTags = {
  Project: 'Project',
  ProjectContent: 'ProjectContent',
  ProjectProfile: 'ProjectProfile',
  Dataset: 'Dataset',
  DatasetList: 'DatasetList',
  Content: 'Content',
  ContentImage: 'ContentImage',
  Metadata: 'Metadata',
  Annotation: 'Annotation',
  AnnotationStats: 'AnnotationStats',
  Export: 'Export',
  ExportContent: 'ExportContent',
  ExportMetadata: 'ExportMetadata',
  PredictionList: 'PredictionList',
  Prediction: 'Prediction',
  PredictionStats: 'PredictionStats',
  Tag: 'Tag',
  TagProperties: 'TagProperties',
  Model: 'Model',
  ModelList: 'ModelList',
  Heatmap: 'Heatmap',
  User: 'User',
  UserList: 'UserList',
  UserProfile: 'UserProfile',
  UserVerification: 'UserVerification',
  Chat: 'Chat',
  ChatList: 'ChatList',
  ChatMessage: 'ChatMessage',
  Organization: 'Organization',
  OrganizationList: 'OrganizationList',
  OrganizationBranding: 'OrganizationBranding',
}
